
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Niklaus H., 96, verstorben am 28. März 2020</b>
    <br />
    <br />
    <i>Einer seiner Söhne sagt:</i>
    <br />
    <p>
  «Mein Vater ist am 28. März in einem Altersheim gestorben, als die Schweiz
  erst zwei Wochen im Lockdown war. Noch war der Virus etwas Fremdes, erst
  wenige Menschen fanden damit den Tod.
    </p>
    <p>
  Wir konnten ihn nicht besuchen, damals gab es auch bei Sterbenden keine
  Ausnahme.
    </p>
    <p>
  Wir spürten bei ihm schon länger nicht mehr allzu viel Lebensfreude. Er hörte
  schlecht und zog sich deshalb sozial zurück. Deshalb glaube ich, dass es für
  ihn gestimmt hat, in dem Moment zu gehen. Ob er nun an Corona oder etwas
  anderem gestorben ist – wir müssen es akzeptieren. Wir können es nicht ändern.
  Jedenfalls hiess es, er habe ruhig gehen können.»
    </p>
    <i>Ein anderer Sohn sagt:</i>
    <p>
  «Er hatte sich gewünscht, dass es – wenn es dann mal so weit wäre – möglichst
  schnell gehen sollte. Dieser Wunsch wurde ihm erfüllt.
    </p>
    <p>
  Mir tun die Leute leid, die in diesen Heimen arbeiten. Die haben es nicht
  einfach. Den Umgang mit den Corona-Toten empfinde ich als zynisch. Gewisse
  Leute kümmern sich kaum um die Sicherheitsmassnahmen. Die persönliche
  Freiheit, der Individualismus werden in der Schweiz höher gewichtet als in
  anderen europäischen Ländern. Die Schweiz ist den USA in diesem Punkt
  ähnlicher als anderen Ländern rundherum.
    </p>
    <p>
  Als in Italien im Frühjahr viele Menschen an Corona gestorben sind, gab es
  grosse Gedenkfeiern. In der Schweiz nichts. Die Toten lassen die meisten kalt.
  Wir haben Milliarden investiert in teure Krebstherapien, damit auch 80-Jährige
  ein paar Jahre länger leben können. Und jetzt spielt das plötzlich alles keine
  Rolle mehr.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;